export const dateFormat = "DD/MM/YYYY";
export const filterOptions = [
  { name: "Customer ID", value: "customerId" },
  { name: "Depot", value: "customerDepot" },
  { name: "Date Range", value: "date" },
  { name: "Reason for Adding", value: "addReason" },
];

export const VALIDATION_RULES = [{ required: true, message: "Please enter value" }];
export const ADD_REMOVE_TYPES = {
  ADD: "Add",
  REMOVE: "Remove",
};
